/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Shared_Hosting_Etos_EarlyExerciseConfiguration_ConfigureEarlyExerciseConfigurationEto } from '../models/Wealthlane_Shared_Hosting_Etos_EarlyExerciseConfiguration_ConfigureEarlyExerciseConfigurationEto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ConfigureEarlyExerciseConfigurationEventHandlerService {

    /**
     * @param requestBody 
     * @returns boolean OK
     * @throws ApiError
     */
    public static postApiAwardApiAppConfigureEarlyExerciseConfigurationEventHandlerConfigureEarlyExercise(
requestBody?: Wealthlane_Shared_Hosting_Etos_EarlyExerciseConfiguration_ConfigureEarlyExerciseConfigurationEto,
): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/configure-early-exercise-configuration-event-handler/configure-early-exercise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
